/* OUTDOOR BILLS — ob-theme.js v2 */
document.addEventListener('DOMContentLoaded', function () {

  /* ─────────────────────────────────────────
     FLOATING HEADER — scroll state
  ───────────────────────────────────────── */
  try {
    var hdr = document.getElementById('ob-floating-header');
    if (hdr) {
      window.addEventListener('scroll', function () {
        hdr.classList.toggle('ob-scrolled', window.scrollY > 60);
      }, { passive: true });
    }
  } catch(e) {}

  /* ─────────────────────────────────────────
     MOBILE NAV — hamburger drawer
  ───────────────────────────────────────── */
  try {
    var hamburger  = document.getElementById('ob-hamburger');
    var mobileNav  = document.getElementById('ob-mobile-nav');
    var mobileClose = document.getElementById('ob-mobile-close');
    var backdrop   = document.getElementById('ob-nav-backdrop');

    function openMobileNav() {
      if (!mobileNav) return;
      mobileNav.classList.add('ob-mobile-open');
      mobileNav.setAttribute('aria-hidden', 'false');
      if (backdrop) { backdrop.classList.add('ob-backdrop-open'); }
      if (hamburger) { hamburger.classList.add('ob-open'); hamburger.setAttribute('aria-expanded', 'true'); }
      document.body.style.overflow = 'hidden';
      // Focus first link
      var firstLink = mobileNav.querySelector('a, button');
      if (firstLink) firstLink.focus();
    }

    function closeMobileNav() {
      if (!mobileNav) return;
      mobileNav.classList.remove('ob-mobile-open');
      mobileNav.setAttribute('aria-hidden', 'true');
      if (backdrop) { backdrop.classList.remove('ob-backdrop-open'); }
      if (hamburger) { hamburger.classList.remove('ob-open'); hamburger.setAttribute('aria-expanded', 'false'); hamburger.focus(); }
      document.body.style.overflow = '';
    }

    if (hamburger) hamburger.addEventListener('click', openMobileNav);
    if (mobileClose) mobileClose.addEventListener('click', closeMobileNav);
    if (backdrop) backdrop.addEventListener('click', closeMobileNav);

    // Close on Escape key
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && mobileNav && mobileNav.classList.contains('ob-mobile-open')) {
        closeMobileNav();
      }
    });

    // Close when a nav link is clicked
    if (mobileNav) {
      mobileNav.querySelectorAll('a').forEach(function (a) {
        a.addEventListener('click', function () {
          closeMobileNav();
        });
      });
    }
  } catch(e) {}

  /* ─────────────────────────────────────────
     SEARCH OVERLAY
  ───────────────────────────────────────── */
  try {
    var searchBtn   = document.getElementById('ob-search-toggle');
    var searchOverlay = document.getElementById('ob-search-overlay');
    var searchClose = document.getElementById('ob-search-close');
    var searchInput = document.getElementById('ob-search-input');

    function openSearch() {
      if (!searchOverlay) return;
      searchOverlay.classList.add('ob-search-open');
      searchOverlay.setAttribute('aria-hidden', 'false');
      if (searchBtn) searchBtn.setAttribute('aria-expanded', 'true');
      if (searchInput) setTimeout(function(){ searchInput.focus(); }, 50);
    }

    function closeSearch() {
      if (!searchOverlay) return;
      searchOverlay.classList.remove('ob-search-open');
      searchOverlay.setAttribute('aria-hidden', 'true');
      if (searchBtn) { searchBtn.setAttribute('aria-expanded', 'false'); searchBtn.focus(); }
    }

    if (searchBtn) searchBtn.addEventListener('click', openSearch);
    if (searchClose) searchClose.addEventListener('click', closeSearch);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && searchOverlay && searchOverlay.classList.contains('ob-search-open')) {
        closeSearch();
      }
    });
  } catch(e) {}

  /* ─────────────────────────────────────────
     SCROLL REVEAL
  ───────────────────────────────────────── */
  try {
    var items = document.querySelectorAll('.ob-reveal');
    if (items.length && 'IntersectionObserver' in window) {
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('ob-vis'); obs.unobserve(e.target); }
        });
      }, { threshold: 0.08, rootMargin: '0px 0px -30px 0px' });
      items.forEach(function (el) { obs.observe(el); });
    }
  } catch(e) {}

  /* ─────────────────────────────────────────
     BACK TO TOP BUTTON
  ───────────────────────────────────────── */
  try {
    var btt = document.getElementById('ob-back-top');
    if (!btt) {
      btt = document.createElement('button');
      btt.id = 'ob-back-top';
      btt.className = 'ob-back-top';
      btt.setAttribute('aria-label', 'Back to top');
      btt.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" aria-hidden="true"><polyline points="18 15 12 9 6 15"/></svg>';
      document.body.appendChild(btt);
    }
    window.addEventListener('scroll', function () {
      btt.classList.toggle('ob-btt-visible', window.scrollY > 600);
    }, { passive: true });
    btt.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  } catch(e) {}

  /* ─────────────────────────────────────────
     QUICK ADD TO CART (AJAX — Shopify Cart API)
  ───────────────────────────────────────── */
  try {
    var toast    = document.getElementById('ob-toast');
    var toastMsg = document.getElementById('ob-toast-msg');
    var toastTimer;

    function showToast(msg) {
      if (!toast) return;
      if (toastMsg) toastMsg.textContent = msg || 'Added to cart!';
      toast.classList.add('ob-toast-show');
      clearTimeout(toastTimer);
      toastTimer = setTimeout(function () {
        toast.classList.remove('ob-toast-show');
      }, 4000);
    }

    function updateCartCount(count) {
      var badges = document.querySelectorAll('.ob-cart-badge');
      var cartLinks = document.querySelectorAll('.ob-nav-cart');
      badges.forEach(function (b) { b.textContent = count; });
      if (count > 0) {
        // Ensure badge exists in each cart link
        cartLinks.forEach(function (link) {
          var existing = link.querySelector('.ob-cart-badge');
          if (!existing) {
            var badge = document.createElement('span');
            badge.className = 'ob-cart-badge';
            badge.setAttribute('aria-hidden', 'true');
            badge.textContent = count;
            link.appendChild(badge);
          } else {
            existing.textContent = count;
          }
          link.setAttribute('aria-label', 'Cart, ' + count + ' item' + (count !== 1 ? 's' : ''));
        });
      }
    }

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.ob-quick-add[data-variant-id]');
      if (!btn || btn.disabled) return;
      e.preventDefault();

      var variantId = btn.getAttribute('data-variant-id');
      var originalText = btn.textContent;
      btn.textContent = 'Adding…';
      btn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
      })
      .then(function (res) {
        if (!res.ok) throw new Error('Cart add failed');
        return res.json();
      })
      .then(function (item) {
        showToast(item.title + ' added!');
        // Fetch updated cart to get item count
        return fetch('/cart.js');
      })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        btn.textContent = '✓ Added';
        setTimeout(function () {
          btn.textContent = originalText;
          btn.disabled = false;
        }, 2000);
      })
      .catch(function () {
        btn.textContent = originalText;
        btn.disabled = false;
        showToast('Could not add item — please try again.');
      });
    });
  } catch(e) {}

  /* ─────────────────────────────────────────
     PRODUCT GRID VIEW TOGGLE (grid / list)
  ───────────────────────────────────────── */
  try {
    var gridBtn = document.getElementById('ob-grid-btn');
    var listBtn = document.getElementById('ob-list-btn');
    var grid    = document.getElementById('ob-all-grid');

    if (gridBtn && listBtn && grid) {
      gridBtn.addEventListener('click', function () {
        grid.classList.remove('ob-list-view');
        gridBtn.classList.add('ob-view-active');
        gridBtn.setAttribute('aria-pressed', 'true');
        listBtn.classList.remove('ob-view-active');
        listBtn.setAttribute('aria-pressed', 'false');
      });
      listBtn.addEventListener('click', function () {
        grid.classList.add('ob-list-view');
        listBtn.classList.add('ob-view-active');
        listBtn.setAttribute('aria-pressed', 'true');
        gridBtn.classList.remove('ob-view-active');
        gridBtn.setAttribute('aria-pressed', 'false');
      });
    }
  } catch(e) {}

  /* ─────────────────────────────────────────
     VIDEO FALLBACK
  ───────────────────────────────────────── */
  try {
    var vid = document.getElementById('ob-yt-video');
    var fb  = document.getElementById('ob-yt-fallback');
    if (vid && fb) {
      vid.addEventListener('error', function () {
        vid.style.display = 'none';
        fb.style.display = 'block';
      });
    }
  } catch(e) {}

  /* ─────────────────────────────────────────
     FAQ ACCORDION (contact page)
  ───────────────────────────────────────── */
  try {
    document.querySelectorAll('.ob-faq-q').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var isOpen = this.getAttribute('aria-expanded') === 'true';
        document.querySelectorAll('.ob-faq-q').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
        document.querySelectorAll('.ob-faq-a').forEach(function (a) { a.classList.remove('ob-faq-open'); });
        if (!isOpen) {
          this.setAttribute('aria-expanded', 'true');
          this.nextElementSibling.classList.add('ob-faq-open');
        }
      });
    });
  } catch(e) {}

});
